import Isotope from 'isotope-layout'
import imagesLoaded from 'imagesloaded'
import { getTextNodesIn, debounce } from '../_functions'

document.addEventListener('DOMContentLoaded', (e) => {
    const parent = e.target.querySelector('.js-posts-iso')
    if (!parent) return

    const searchInput = e.target.querySelector('.js-blog-search')
    const selectInput = e.target.querySelector('.js-category-search')

    const postIso = new Isotope(parent, {
        itemSelector: '.js-posts-iso-item',
        transitionDuration: 400,
        percentPosition: true,
        masonry: { columnWidth: '.grid-sizer' }
    })

    imagesLoaded(parent, () => postIso.layout())

    const arrangePostsIso = () => {
        postIso.arrange({
            filter: (itemElem) => {
                if (!(itemElem instanceof HTMLElement)) return true

                const selectedVal = selectInput?.value
                const query = searchInput?.value.trim() || ''
                const qsRegex = query && new RegExp(query, 'gi')

                // 🔎 Catégories
                const categories = (itemElem.dataset.categories || '')
                    .split(',')
                    .map(Number)

                const hasCategory =
                    !selectedVal ||
                    selectedVal === 'all' ||
                    categories.includes(+selectedVal)

                // 🔎 Texte
                const hasText =
                    !qsRegex || qsRegex.test(getTextNodesIn(itemElem))

                return hasCategory && hasText
            }
        })
    }

    const debouncedArrange = debounce(arrangePostsIso, 300)

    // 🔎 Events
    searchInput?.addEventListener('input', debouncedArrange)
    selectInput?.addEventListener('change', debouncedArrange)

    // 🚫 Empêcher Enter dans le champ recherche
    searchInput?.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
            e.preventDefault()
        }
    })

    // ---------------- Modal filtres ----------------

    const openBtn = e.target.querySelector('.js-open-filters-modal')
    const closeBtn = e.target.querySelector('.js-close-filters-modal')
    const searchModal = e.target.querySelector('.js-search-modal')
    const header = e.target.querySelector('.js-header')
    const notificationBar = e.target.querySelector('.part-notification')

    const toggleModal = (open) => {
        searchModal?.classList.toggle('is-open', open)
        header?.classList.toggle('mobile-menu-open', open)
        notificationBar?.classList.toggle('hide', open)
    }

    openBtn?.addEventListener('click', () => toggleModal(true))
    closeBtn?.addEventListener('click', () => toggleModal(false))

})